import React from 'react';
import { useSelector } from 'react-redux';
import usePageVisitTracker from '../../hooks/usePageVisitTracker';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../TopComponents/TopBanner.css';
import { FaArrowRight } from "react-icons/fa";


const MainBanner = () => {
  const { trackPage } = usePageVisitTracker({ autoTrack: false });

  // Get homepage data from Redux
  const homeText = useSelector((state) => state.HomeText);
  const homeBgImage = useSelector((state) => state.HomeBgImage);

  // Split homeText into two parts (e.g., "YOUR CARGO Our Commitment" -> ["YOUR CARGO", "Our Commitment"])
  const splitHomeText = () => {
    if (!homeText) return { firstLine: 'YOUR CARGO', secondLine: 'Our Commitment' };
    
    // Split at "Our" to separate the two parts
    const parts = homeText.split(/\s+(?=Our)/);
    return {
      firstLine: parts[0]?.trim() || 'YOUR CARGO',
      secondLine: parts[1]?.trim() || 'Our Commitment'
    };
  };

  const { firstLine, secondLine } = splitHomeText();

  return (
    <div
      className="container-fluid"
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#001657',
        height: '40vh',
        minHeight: '280px',
        maxHeight: '350px',
        overflow: 'hidden',
        display: 'flex',
        position: 'relative'
      }}
    >
      <div className="row text-center text-white w-100 align-items-center" style={{ height: '100%' }}>
        
        {/* LEFT TEXT */}
        <div
          className="col-lg-6 col-md-6 col-sm-12 text-start"
          style={{ paddingLeft: '15%' }}
        >
          <div className='mobile-view'>
            <h1 className="top-banner-heading" style={{ lineHeight: '1.1', marginBottom: '0.3rem' }}>
              {firstLine}
            </h1>
          </div>
          <h1 className="reliability" style={{ lineHeight: '1.1', marginBottom: '0' }}>
            {secondLine}
          </h1>
        </div>

        {/* RIGHT IMAGE */}
        <div
          className="col-lg-6 col-md-6 col-sm-12 position-relative"
          style={{
            padding: 0,
            height: '100%',
            overflow: 'hidden'
          }}
        >
          <img
            className="img-fluid h-100 w-100"
            src={homeBgImage || "./NyhavnFrontpage.jpg"}
            alt="Banner"
            style={{
              objectFit: 'cover',
              clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 15% 100%)',
              height: '100%',
              width: '100%'
            }}
          />

          <div
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              backgroundColor: '#001657',
              padding: '15px',
              borderRadius: '8px',
              boxShadow: '0px 2px 8px 0px #00000014',
              zIndex: 10,
              width: '286px',
              color: 'white',
            }}
            className="track"
          >
            <div className="mb-2">
              <h3 style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '0.4rem', color: 'white' }}>
                Track & Trace
              </h3>
              <p style={{ fontSize: '0.8rem', margin: 0, color: '#ffffff99' }}>
                Track & Trace only shows spirit system info
              </p>
            </div>

            {/* Track and Trace New button */}
            <div style={{ marginTop: '10px', borderTop: '1px solid #ffffff', paddingTop: '10px' }}>
              <a
                href="https://sac-icargo.ibsplc.aero/icargoneoportal/app/main/#/app"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackPage('/new-track-trace')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  width: '100%',
                  padding: '9px 12px',
                  backgroundColor: '#232323',
                  color: 'white',
                  fontWeight: '700',
                  fontSize: '0.75rem',
                  borderRadius: '4px',
                  textDecoration: 'none',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase',
                  transition: 'background-color 0.2s',
                }}
              >
                Track and Trace <FaArrowRight />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainBanner;